import { render } from "./App.vue?vue&type=template&id=54d80cf8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/denis/Coding/projects/stadt-passau-website-typo3-14lts/extensions/glossar/Resources/Private/Vue/glossar-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__